// Prompt ID Constants
export const PROMPT_IDS = {
  SITE_VERSION_COMMENTS: 1,
  FORM_GENERATION: 2
}

// Prompt Categories
export const PROMPT_CATEGORIES = {
  COMMENTS: 'comments',
  FORMS: 'forms'
}

// Response Formats
export const RESPONSE_FORMATS = {
  TEXT: 'text',
  HTML: 'html',
  JSON: 'json'
}

// Default options for different prompt types
export const DEFAULT_PROMPT_OPTIONS = {
  [PROMPT_IDS.SITE_VERSION_COMMENTS]: {
    responseFormat: RESPONSE_FORMATS.HTML,
    responseJson: false
  },
  [PROMPT_IDS.FORM_GENERATION]: {
    responseFormat: RESPONSE_FORMATS.JSON,
    responseJson: true
  }
} 